import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_DETTACHFILE_FULFILLED = "FETCH_DETTACHFILE_FULFILLED";
export const FETCH_DETTACHFILE_REJECTED = "FETCH_DETTACHFILE_REJECTED";
export const FETCH_DETTACHFILE_PENDING = "FETCH_DETTACHFILE_PENDING";
export const RESET_DETTACHFILE = "RESET_DETTACHFILE"

export function dettachFile(applicationAttachmentId, applicationId) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_DETTACHFILE",
            payload: axios({
                method: "delete",
                url: `${API_BASE}/api/v3/second-opinion/dettach-file-from-application?applicationAttachmentId=${applicationAttachmentId}&applicationId=${applicationId}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetDettachFile() {
    return (dispatch) => {
        dispatch({
            type: "RESET_DETTACHFILE",
        });
    };
}




